// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from "./utils/AuthContext.jsx";
import './App.css';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Homepage from './pages/Home.jsx';
import Gallery from './pages/Gallery.jsx';
import TnC from './pages/TnC.jsx';
import ReturnPolicy from './pages/ReturnPolicy.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import About from './pages/About'; 
import Services from './pages/Services'; 
import Help from './pages/Help'; 
import Career from './pages/Career.jsx';
import ContactPage from './pages/Contact.jsx';
import ContactForm from './pages/ContactForm.jsx';
import DashboardMessages from './pages/DashboardMessages.jsx';
import Community from './pages/Community.jsx';
import CommunityPage from './pages/CommunityPage.jsx';
import Register from './pages/Register';
import VerifyEmail from "./pages/VerifyEmail";
import Login from "./pages/Login.jsx";
import PrivateRoute from "./pages/Profile.jsx";
import Profile from "./pages/Profile.jsx";
import ProfileSettings from "./pages/ProfileSettings.jsx";
import AccountProfile from "./pages/AccountProfile.jsx";
import DeleteAccount from "./pages/DeleteAccount.jsx";
import Wishlist from './pages/Wishlist.jsx';
import ProductManage from './pages/ProductManage.jsx';
import ProductItenary from './pages/ProductItenary.jsx';
import BidManagement from './pages/BidManagement.jsx';
import OrderManagement from './pages/OrderManagement.jsx';
import CanceledOrders from './pages/OrdersCanceled.jsx';
import ClosedOrders from './pages/OrdersClosed.jsx';
import SalesManagement from './pages/SalesManagement.jsx';
import SalesDelivered from './pages/SalesDelivered.jsx';
import CartPage from './pages/Cart.jsx';
import CheckoutPage from "./pages/Checkout.jsx";
import Success from "./pages/Success.jsx";
import AdminProdMgmt from './pages/AdminProductManagement.jsx';

import Stylish from './components/ExampleSection.jsx';


function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/fa" replace />} />
            <Route path="/:lang?" element={<Homepage/>}/>
            <Route path="/:lang/gallery" element={<Gallery/>}/>
            <Route path="/:lang/our-terms-and-conditions" element={<TnC/>}/>
            <Route path="/:lang/our-privacy-policy" element={<PrivacyPolicy/>}/>
            <Route path="/:lang/our-return-policy" element={<ReturnPolicy/>}/>
            <Route path="/:lang/about" element={<About/>}/>
            <Route path="/:lang/services" element={<Services/>}/>
            <Route path="/:lang/help" element={<Help/>}/>
            <Route path="/:lang/careers" element={<Career/>}/>
            <Route path="/:lang/contact" element={<ContactPage/>}/>
            <Route path="/:lang/contactform/:receiverId/:itemId" element={<ContactForm/>}/>
            <Route path="/:lang/messages" element={<DashboardMessages/>}/>
            <Route path="/:lang/community" element={<Community/>}/>
            <Route path="/:lang/community/:id" element={<CommunityPage/>}/>
            <Route path="/:lang/register" element={<Register/>}/>
            <Route path="/:lang/verify-email" element={<VerifyEmail />} />
            <Route path="/:lang/login" element={<Login/>}/>
            <Route path="/:lang/profile" element={<PrivateRoute><Profile/></PrivateRoute>}/>
            <Route path="/:lang/profile/update" element={<ProfileSettings/>}/>
            <Route path="/:lang/profile/account/:type" element={<AccountProfile/>}/>
            <Route path="/:lang/bye/:name?" element={<DeleteAccount/>}/>
            <Route path="/:lang/wishlist" element={<Wishlist/>}/>
            <Route path="/:lang/productlist/manage" element={<ProductManage/>}/>
            <Route path="/:lang/productitenary/:productId/:name?/:artist?/:description?/:category?/:material?" element={<ProductItenary />} />
            <Route path="/:lang/review/bids" element={<BidManagement/>}/>
            <Route path="/:lang/review/open-orders" element={<OrderManagement/>}/>
            <Route path="/:lang/review/canceled-orders" element={<CanceledOrders/>}/>
            <Route path="/:lang/review/closed-orders" element={<ClosedOrders/>}/>
            <Route path="/:lang/review/my-sales" element={<SalesManagement/>}/>
            <Route path="/:lang/review/delivered-sales" element={<SalesDelivered/>}/>
            <Route path="/:lang/cart" element={<CartPage/>}/>
            <Route path="/:lang/checkout" element={<CheckoutPage/>}/>
            <Route path="/:lang/ordersuccess" element={<Success/>}/>
            <Route path="/:lang/adminprodmgmt" element={<AdminProdMgmt/>}/>
            <Route path="/:lang/stylish" element={<Stylish/>}/>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;